<template>
    <app-layout>
        <Head>
            <title>Stammdaten</title>
        </Head>

        <template v-slot:overline>
            <translate>Stammdaten</translate>
        </template>

        <template v-slot:headline>{{ this.$page.props.user.name }}</template>

        <div class="account">
            <div class="row">
                <div class="col">
                    <form @submit.prevent="submit">
                        <div class="row">
                            <div class="col col-3">
                                <card>
                                    <card-header>
                                        <card-overline>
                                            <translate>Account</translate>
                                        </card-overline>
                                    </card-header>
                                    <card-content>
                                        <description-group>
                                            <description-element :caption="form.client_no" :title="this.$gettext('Kundennummer')" />
                                            <description-element :caption="form.email" :title="this.$gettext('Email')" />
                                            <description-element :caption="form.vat_id" :title="this.$gettext('UST-ID')" v-if="clientUser.is_checked === true" />
                                        </description-group>
                                    </card-content>
                                </card>
                                <card>
                                    <card-header>
                                        <card-overline>
                                            <translate>Einstellungen</translate>
                                        </card-overline>
                                    </card-header>
                                    <card-content>
                                        <form-select id="language" :label="this.$gettext('Sprache')" :options="languageOptions"
                                                     v-model="form.language" :error="form.errors.language"/>
                                    </card-content>
                                </card>
                            </div>
                            <div class="col">
                                <div class="row">
                                    <div class="col">
                                        <card>
                                            <card-header>
                                                <card-overline>
                                                    <translate>Stammdaten</translate>
                                                </card-overline>
                                                <card-title>
                                                    <translate>Unternehmen</translate>
                                                </card-title>
                                            </card-header>
                                            <card-content>
                                                <form-input id="company" :label="this.$gettext('Firma')" v-model="form.company"
                                                            :error="form.errors.company"/>
                                                <form-group>
                                                    <form-input type="text" id="street" :label="this.$gettext('Straße')" v-model="form.street"
                                                                :error="form.errors.street" class="three-four"
                                                                autocomplete="street-address"/>
                                                    <form-input type="text" id="street_no" :label="this.$gettext('Nr')" v-model="form.street_no"
                                                                :error="form.errors.street_no" class="one-four"/>
                                                </form-group>
                                                <form-group>
                                                    <form-input type="text" id="zip" :label="this.$gettext('Plz')" v-model="form.zip"
                                                                :error="form.errors.zip" class="one-four"
                                                                autocomplete="postal-code"/>
                                                    <form-input type="text" id="city" :label="this.$gettext('Ort')" v-model="form.city"
                                                                :error="form.errors.city" class="three-four"
                                                                autocomplete="address-level2"/>
                                                </form-group>
                                                <form-select id="client_country_id" :label="this.$gettext('Land')" :options="countryOptions"
                                                             v-model="form.client_country_id"
                                                             :error="form.errors.client_country_id"/>
                                                <form-input type="text" id="vat_id" :label="this.$gettext('UST-ID')" v-model="form.vat_id"
                                                            :error="form.errors.vat_id"  v-if="clientUser.is_checked !== true"/>
                                            </card-content>
                                        </card>

                                        <card>
                                            <card-header>
                                                <card-overline>
                                                    <translate>Stammdaten</translate>
                                                </card-overline>
                                                <card-title>
                                                    <translate>Kontakt</translate>
                                                </card-title>
                                            </card-header>

                                            <card-content>
                                                <form-group>
                                                    <form-input id="name" :label="this.$gettext('Name')" v-model="form.name"
                                                                :error="form.errors.name"/>

                                                    <form-input id="street_additional" :label="this.$gettext('Abteilung (optional)')"
                                                                v-model="form.street_additional"
                                                                :error="form.errors.street_additional"/>
                                                </form-group>
                                                <form-group>
                                                    <form-input type="text" id="phone" :label="this.$gettext('Telefon (optional)')" v-model="form.phone"
                                                                :error="form.errors.phone" />

                                                    <form-input type="text" id="website" :label="this.$gettext('Webseite (optional)')" v-model="form.website"
                                                                :error="form.errors.website" />
                                                </form-group>
                                                <form-group>
                                                    <form-input type="text" id="invoice_mail" :label="this.$gettext('Email Adresse für Rechnungen (optional)')" v-model="form.invoice_mail"
                                                                :error="form.errors.invoice_mail" />
                                                </form-group>
                                            </card-content>
                                        </card>

                                        <card>
                                            <card-header>
                                                <card-overline>
                                                    <translate>Sicherheit</translate>
                                                </card-overline>
                                                <card-title>
                                                    <translate>Passwort</translate>
                                                </card-title>
                                            </card-header>

                                            <card-content>
                                                <card class="card--minify card--message error " v-if="form.errors.password_info">
                                                    <card-content v-html="form.errors.password_info"></card-content>
                                                </card>
                                                <form-group>
                                                    <form-password id="current_password" :label="this.$gettext('Altes Passwort')" v-model="form.current_password"
                                                                   :error="form.errors.current_password" class="one-half"/>

                                                    <div style="flex: 1 1 50%;"></div>
                                                </form-group>
                                                <form-group>
                                                    <form-password id="password" :label="this.$gettext('Neues Passwort')"
                                                                   v-model="form.password"
                                                                   :error="form.errors.password" class="one-half"/>
                                                    <form-password id="password_confirmation" :label="this.$gettext('Neues Passwort bestätigen')"
                                                                   v-model="form.password_confirmation"
                                                                   :error="form.errors.password_confirmation" class="one-half"/>

                                                </form-group>
                                            </card-content>
                                        </card>
                                    </div>
                                </div>

                                <div class="row row--sticky" v-sticky>
                                    <div class="col">
                                        <form-actions>
                                            <form-button type="submit" color="secondary" class="btn--block" :disabled="form.processing" :class="{'btn--processing': form.processing}">
                                                <translate>Speichern</translate>
                                            </form-button>
                                        </form-actions>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </form>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from '@partfactory/Layouts/AppLayout';
import Card from '@partfactory/Shared/Card/Card';
import CardContent from '@partfactory/Shared/Card/CardContent';
import CardHeader from '@partfactory/Shared/Card/CardHeader';
import CardTitle from '@partfactory/Shared/Card/CardTitle';
import CardOverline from '@partfactory/Shared/Card/CardOverline';
import {useForm} from '@inertiajs/vue3';
import FormInput from '@partfactory/Shared/Form/FormInput';
import FormGroup from '@partfactory/Shared/Form/FormGroup';
import FormSelect from '@partfactory/Shared/Form/FormSelect';
import FormActions from '@partfactory/Shared/Form/FormActions';
import FormButton from '@partfactory/Shared/Form/FormButton';
import DescriptionGroup from '@partfactory/Shared/Elements/DescriptionGroup';
import DescriptionElement from '@partfactory/Shared/Elements/DescriptionElement';
import FormPassword from '@partfactory/Shared/Form/FormPassword';

export default {
    name: 'Account',
    components: {
        FormPassword,
        DescriptionElement,
        DescriptionGroup,
        FormButton,
        FormActions,
        FormSelect,
        FormGroup, FormInput, CardOverline, CardTitle, CardHeader, CardContent, Card, AppLayout
    },
    props: {
        clientUser: Object,
        clientCountries: Object,
    },
    data() {
        const form = useForm({
            client_no: this?.clientUser?.client_no,
            email: this?.clientUser?.email,
            company: this?.clientUser?.company,
            name: this?.clientUser?.name,
            street_additional: this?.clientUser?.street_additional,
            street: this?.clientUser?.street,
            street_no: this?.clientUser?.street_no,
            zip: this?.clientUser?.zip,
            city: this?.clientUser?.city,
            client_country_id: this?.clientUser?.client_country_id,
            phone: this?.clientUser?.phone,
            website: this?.clientUser?.website,
            vat_id: this?.clientUser?.vat_id,
            language: this?.clientUser?.language,
            current_password: null,
            password: null,
            password_confirmation: null,
            invoice_mail: this?.clientUser?.invoice_mail,
        });

        return {form};
    },
    computed: {
        countryOptions() {
            return this.clientCountries;
        },
        languageOptions() {
            return this.$page.props.languages.map(lang => {
                return {value: lang.id, text: this.$gettext(lang.language_name)};
            });
        },
    },
    methods: {
        submit() {
            this.form
                .transform(data => ({
                    ...data,
                    _token: this.$page.props.csrf_token,
                }))
                .patch(this.$$route('account.update'), {
                    preserveScroll: true,
                    onSuccess: () => {
                        this.form.reset('current_password', 'password', 'password_confirmation');
                    },
                    onError: () => {
                        this.form.reset('current_password', 'password', 'password_confirmation');
                    }
                });
        }
    },
};
</script>
